import React, { useState } from "react";

import { Tooltip } from "antd";
import { toast } from "react-toastify";

import styles from "./ClaimCard.module.css";

// Shared by ActiveIdentityCard and RemovedIdentityCard, which were previously
// byte-for-byte identical apart from the `idPrefix` used in their DOM ids
// (activeIdentity* vs removedIdentity*).
export const IdentityCard = ({ data, idPrefix }) => {
  const [isCopied, setIsCopied] = useState(false);

  function copyToClipboard(id) {
    let copyText = document.getElementById(id);
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard
      .writeText(copyText.value)
      .then(() => {
        setIsCopied(true);

        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Failed to copy to clipboard:", error);
        toast.error("Couldn't copy to clipboard");
      });
  }

  return (
    <div className="max-[500px]:px-0 border rounded-xl p-6 bg-[#b39dd4] flex flex-col gap-3">
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`${idPrefix}TrustedIssuer-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Trusted Issuer Wallet
        </label>
        <div className="flex gap-2 justify-center w-full">
          <input
            type="text"
            id={`${idPrefix}TrustedIssuer-${data.id}`}
            name={`${idPrefix}TrustedIssuer-${data.id}`}
            className={styles.cardField}
            value={data?.trustedIssuer || ""}
            readOnly
          ></input>
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(`${idPrefix}TrustedIssuer-${data.id}`)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <p className="max-[500px]:text-sm">Trusted Issuer Email</p>
        <div className="flex gap-2 justify-center">
          <p className="max-[500px]:text-xs">{data?.trustedIssuerEmail || "N/A"}</p>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`${idPrefix}TransactionHash-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Transaction hash
        </label>
        <div className="flex gap-2 justify-center w-full">
          <input
            type="text"
            id={`${idPrefix}TransactionHash-${data.id}`}
            name={`${idPrefix}TransactionHash-${data.id}`}
            className={styles.cardField}
            value={data?.transactionHash || ""}
            readOnly
          ></input>
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(`${idPrefix}TransactionHash-${data.id}`)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <p className="max-[500px]:text-sm">Date</p>
        <div className="flex gap-2 justify-center">
          <p className="max-[500px]:text-xs">
            {data?.createdAt
              ? new Date(data.createdAt).toLocaleDateString("en-us", {
                  weekday: "long",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
              : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
};
